module.exports = __webpack_public_path__ + "img/SWF_picture_icon@2x.5cb70c33.png";